import { createSelector } from '@ngrx/store';
import { denormalize } from 'normalizr';
import {
  ByKey,
  createListStateIdsSelector,
  createListStateParamsSelector,
  createStateErrorsSelector,
  createStateLoadingSelector,
  createStateSuccessSelector,
  IdType,
  ListState
} from '@industi/ngx-common';
import { EntityState } from '../../../entity/entity.reducer';
import { EntityTypes } from '../../../entity/entity-types';
import { createEntitiesSelector } from '../../../entity/entities.reducer';
import { createSymfonyTotalCountSelector } from '../../../symfony/list/selectors/list.selectors';
import { Entities } from '../../../entity/entities';
import { getCarbonFormCommissionListState } from '../form-commission.reducer';
import { CarbonFormCommission } from '../models/form-commission';

const createState = (id: IdType) => createSelector(
  getCarbonFormCommissionListState,
  (state: ByKey<ListState>) => state && state[id]
);

const createStateByContext = (id: IdType) => createListStateIdsSelector(createState(id));

export const createCarbonFormCommissionListData = (id: IdType) => createSelector(
  createStateByContext(id),
  createEntitiesSelector([
    EntityTypes.carbonFormCommission
  ]),
  (
    ids: IdType[],
    entities: EntityState
  ) => denormalize(ids, [Entities[EntityTypes.carbonFormCommission]], entities) as CarbonFormCommission[]
);

export const createCarbonFormCommissionListLoading = (id: IdType) => createStateLoadingSelector(
  createState(id));

export const createCarbonFormCommissionListSuccess = (id: IdType) => createStateSuccessSelector(
  createState(id));

export const createCarbonFormCommissionListErrors = (id: IdType) => createStateErrorsSelector(
  createState(id));

export const createCarbonFormCommissionListTotalCount = (id: IdType) => createSymfonyTotalCountSelector(
  createState(id));

export const createCarbonFormCommissionListParams = (id: IdType) => createListStateParamsSelector(
  createState(id));
